import axios from 'axios';
import AccessToken from '@/services/auth';
import signature from '@/services/signature';

const ACCESS_TOKEN = AccessToken();
const BASE_URI = process.env.VUE_APP_API_BASE_URI;

let config = {
	headers: {
		Authorization: 'Bearer ' + ACCESS_TOKEN.token,
		TimeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
	}
};

class BillsApi {
	async list(queryString = '') {
		try {
			const response = await axios.get(BASE_URI + '/v1/bills' + signature(queryString), config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	async info(id) {
		try {
			const response = await axios.get(BASE_URI + '/v1/bills/' + id + signature(), config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	// Preview-only: POST the cashier's draft edits (bill/item discount, shipping)
	// so the backend returns server-computed totals (incl. tax) without mutating
	// the bill. Pass an empty body to print the persisted state as-is.
	async print(id, data = {}) {
		try {
			const response = await axios.post(BASE_URI + '/v1/bills/' + id + '/print' + signature(), data, config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	async getPayment(id) {
		try {
			const response = await axios.get(BASE_URI + '/v1/bills/' + id + '/payment' + signature(), config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	async payment(id, data) {
		try {
			const response = await axios.post(BASE_URI + '/v1/bills/' + id + '/payment' + signature(), data, config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	async void(id, data) {
		try {
			const response = await axios.put(BASE_URI + '/v1/bills/' + id + '/void' + signature(), data, config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	async refund(id, data) {
		try {
			const response = await axios.put(BASE_URI + '/v1/bills/' + id + '/refund' + signature(), data, config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	async taxInvoice(id, data) {
		try {
			const response = await axios.post(BASE_URI + '/v1/bills/' + id + '/tax-invoice' + signature(), data, config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	async voidTaxInvoice(id, data) {
		try {
			const response = await axios.put(BASE_URI + '/v1/bills/' + id + '/tax-invoice/void' + signature(), data, config);
			return response;
		} catch (err) {
			throw err;
		}
	}
}

export const Bills = new BillsApi();
